import { ref, onMounted, onUnmounted } from '@nuxtjs/composition-api';
import { debounce } from 'throttle-debounce-ts';
const scrollY = ref(0);
const activeListeners = ref(0);
const updateScroll = debounce(10, () => {
    scrollY.value = window.scrollY;
});
export function useGlobalScrollTracker() {
    onMounted(() => {
        if (!activeListeners.value) {
            window.addEventListener('scroll', updateScroll, { passive: true });
        }
        activeListeners.value++;
    });
    onUnmounted(() => {
        activeListeners.value--;
        if (!activeListeners.value) {
            window.removeEventListener('scroll', updateScroll);
        }
    });
    return { scrollY };
}
